import { Model } from 'pinia-orm';
import Application from './Application';
import User from './User';
import Competence from './Competence';

export default class ApplicationCompetence extends Model {

    static get entity () {
        return 'application_competences';
    }

    static fields () {
        return {
            id: this.uid(),
            score: this.number(null),
            user_id: this.attr(null),
            application_id: this.attr(null),
            competence_id: this.attr(null),
            created_at: this.attr(null),
            application: this.belongsTo(Application, 'application_id'),
            user: this.belongsTo(User, 'user_id'),
            competence: this.belongsTo(Competence, 'competence_id'),
        }
    }

    static mutators() {
        return {
            score: {
                get: (value) => Math.round(value),
            }
        }
    }
}
